var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.3333H20.0167M15.1668 14.9998C15.5668 13.8975 16.3415 12.9709 17.3554 12.3818C18.3693 11.7928 19.558 11.5789 20.7137 11.7775C21.8694 11.976 22.9185 12.5745 23.6776 13.4681C24.4368 14.3618 24.8577 15.4939 24.8668 16.6665C24.8668 19.9998 19.8668 21.6665 19.8668 21.6665M25 3.33325H10C9.11595 3.33325 8.2681 3.68444 7.64298 4.30956C7.01786 4.93468 6.66667 5.78253 6.66667 6.66659V33.3333C6.66667 34.2173 7.01786 35.0652 7.64298 35.6903C8.2681 36.3154 9.11595 36.6666 10 36.6666H30C30.8841 36.6666 31.7319 36.3154 32.357 35.6903C32.9821 35.0652 33.3333 34.2173 33.3333 33.3333V11.6666L25 3.33325Z",
    stroke: "#295D92",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfQuestion);
export default __webpack_public_path__ + "static/media/pdf-question.d312ce2167ebcebd89c7831514b1ae27.svg";
export { ForwardRef as ReactComponent };